<template>
  <Carousel :autoplay="5000" :wrap-around="true" pause-autoplay-on-hover>
    <Slide v-for="image in images" :key="image.id">
      <img :src="image.url" />
    </Slide>

    <template #addons>
      <Navigation />
      <Pagination />
    </template>
  </Carousel>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";
export default defineComponent({
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },

  data() {
    return {
      images: [
        {
          id: 1,
          // url: process.env.VUE_APP_PUBLIC_PATH + `/images/microfisica/f01.webp`,
          // url: "@/assets/images/microfisica/f01.webp",
          // Url from assets/images/microfisica
          url: require("@/assets/images/microfisica/f01.webp"),
        },
        {
          id: 2,
          // url: process.env.VUE_APP_PUBLIC_PATH + `/images/f02.webp`,
          url: require("@/assets/images/microfisica/f02.webp"),
        },
        {
          id: 3,
          // url: process.env.VUE_APP_PUBLIC_PATH + `/images/f03.webp`,
          url: require("@/assets/images/microfisica/f03.webp"),
        },
        {
          id: 4,
          // url: process.env.VUE_APP_PUBLIC_PATH + `/images/f04.webp`,
          url: require("@/assets/images/microfisica/f04.webp"),
        },
        {
          id: 5,
          // url: process.env.VUE_APP_PUBLIC_PATH + `/images/f05.webp`,
          url: require("@/assets/images/microfisica/f05.webp"),
        },
      ],
    };
  },
});
</script>

<style>
.carousel__pagination {
  margin-top: 0px;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  color: whitesmoke;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
  background-color: rgb(14, 159, 255);
}

.carousel__pagination-button {
  background-color: rgb(216, 216, 216);
}
.carousel__pagination-button--active {
  background-color: rgb(14, 159, 255);
}
</style>
